<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <Breadcrumbs :items="breadcrumbs" page_title="library" />
      <!-- <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ "Library" }}
        </label>
      </v-system-bar> -->

      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="250"
            height="60"
            >{{ "Library" }}</title-block
          >
        </v-flex>
      </v-layout>
      <v-row>
        <v-spacer></v-spacer>
        <v-col xs="12" sm="2" class="d-flex justify-end">
          <v-btn
            dark
            class="add_btn text-capitalize white--text mr-10"
            color="#A6CC39"
            style="border-radius: 8px !important"
            @click="AddArticle()"
          >
            <v-icon style="color: #ffffff" class="mr-1" :small="true"
              >mdi-plus-box-outline</v-icon
            >
            <span style="font-size: 14px; color: #ffffff">{{ "Add New" }}</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="loading" class="mt-5">
        <v-col cols="2" v-for="n in 12" :key="n">
          <v-skeleton-loader
            class="mx-auto"
            max-width="150"
            max-height="150"
            type="image"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row class="mr-0 mr-2 ma-2" v-else>
        <v-card
          class="mx-3 my-5 "
          style="border-radius: 16px"
          v-show="bullet == 'bullet'"
        >
          <v-list>
            <v-list-item-group
              v-for="item in items"
              :key="item.id"
              class="list-style"
            >
              <v-list-item>
                @click="goLibraryWithName(item, (showEditDialog = false))"
              </v-list-item>
              <v-col cols="12" md="2" lg="1" v-show="item.status == true">
                <v-img :src="item.orgImage" class="list_img"></v-img>
              </v-col>
              <v-col cols="12" md="2" lg="1" v-show="item.status == false">
                <v-img :src="item.orgImage" class="inactivelist_img"></v-img>
              </v-col>
              <v-col cols="12" md="8" lg="9">
                <v-list-item-content style="color: #424242">
                  <v-list-item-title style="font-size: 18px">{{
                    item.topicName
                  }}</v-list-item-title>

                  <v-list-item-subtitle>{{
                    item.description
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="2" lg="2" class="d-flex justify-end">
                <v-sheet
                  height="20px"
                  width="65px"
                  line-height="30px"
                  v-show="item.status == true"
                  style="background-color:#6fdc42;"
                  class="status_list"
                >
                  <v-icon class="circle">mdi-circle</v-icon>
                  {{ $t("active") }}
                </v-sheet>
                <v-sheet
                  height="20px"
                  width="65px"
                  line-height="30px"
                  v-show="item.status == false"
                  class="inactivestatus_list"
                >
                  <v-icon class="circle">mdi-circle</v-icon>
                  {{ $t("inactive") }}
                </v-sheet>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      class="editbtn"
                      style="margin-bottom: 5px"
                    >
                      <v-icon style="color: #424242">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    class="d-flex flex-column align-start"
                    style="padding: 0; border-radius: 8px"
                  >
                    <v-list-item class="list-item-padding preview">
                      <v-btn
                        color="#424242"
                        style="font-size: 11px; width: 100px"
                        text
                        class="text-capitalize"
                        @click="
                          goLibraryWithName(item, (showEditDialog = true))
                        "
                      >
                        <v-icon left>mdi-file-document-edit-outline</v-icon>
                        {{ $t("edit") }}
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="list-item-padding preview">
                      <v-btn
                        color="error"
                        style="font-size: 11px; width: 100px"
                        text
                        class="text-capitalize"
                        @click="checkTopicDelete(item)"
                      >
                        <v-icon left>mdi-trash-can-outline</v-icon>
                        {{ $t("delete") }}
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-list-item-group>
          </v-list>
        </v-card>
        <template v-if="grid == 'grid'">
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            v-for="item in items"
            :key="item.id"
            class="library lg5-custom"
          >
            <v-card
              class="mx-auto library_card "
              style="border-radius: 16px; padding-top: 12px"
              elevation="3"
              height="250"
              @click="goLibraryWithName(item, (showEditDialog = false))"
            >
              <v-img
                :src="item.orgImage"
                height="160px"
                class="library_img"
                v-show="item.status == true"
              >
                <v-sheet
                  height="20px"
                  width="60px"
                  line-height="30px"
                  class="status white--text"
                  style="background-color:#6fdc42;"
                >
                  <v-icon class="circle">mdi-circle</v-icon>
                  {{ $t("active") }}
                </v-sheet>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      class="editbtn"
                      style="left: 83%; top: 4%"
                    >
                      <v-icon style="color: #ffffff">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    class="d-flex flex-column align-start"
                    style="padding: 0; border-radius: 8px"
                  >
                    <v-list-item class="list-item-padding preview">
                      <v-btn
                        color="#424242"
                        style="font-size: 11px; width: 100px"
                        text
                        class="text-capitalize"
                        @click="
                          goLibraryWithName(item, (showEditDialog = true))
                        "
                      >
                        <v-icon left>mdi-file-document-edit-outline</v-icon>
                        {{ $t("edit") }}
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="list-item-padding preview">
                      <v-btn
                        color="error"
                        style="font-size: 11px; width: 100px"
                        text
                        class="text-capitalize"
                        @click="checkTopicDelete(item)"
                      >
                        <v-icon left>mdi-trash-can-outline</v-icon>
                        {{ $t("delete") }}
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-img>

              <v-img
                :src="item.orgImage"
                height="160px"
                class="library_img_inactive"
                v-show="item.status == false"
              >
                <v-sheet
                  v-show="item.status == false"
                  height="20px"
                  width="60px"
                  line-height="30px"
                  style="background-color: #c4c4c4;"
                  class="inactive_status white--text"
                >
                  <v-icon class="circle">mdi-circle</v-icon>
                  {{ $t("inactive") }}
                </v-sheet>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      class="editbtn"
                      style="left: 83%; top: 4%"
                    >
                      <v-icon style="color: #ffffff">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    class="d-flex flex-column align-start"
                    style="padding: 0; border-radius: 8px"
                  >
                    <v-list-item class="list-item-padding preview">
                      <v-btn
                        color="#424242"
                        style="font-size: 11px; width: 100px"
                        text
                        class="text-capitalize"
                        @click="
                          goLibraryWithName(item, (showEditDialog = true))
                        "
                      >
                        <v-icon left>mdi-file-document-edit-outline</v-icon>
                        {{ $t("edit") }}
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="list-item-padding preview">
                      <v-btn
                        color="error"
                        style="font-size: 11px; width: 100px"
                        text
                        class="text-capitalize"
                        @click="checkTopicDelete(item)"
                      >
                        <v-icon left>mdi-trash-can-outline</v-icon>
                        {{ $t("delete") }}
                      </v-btn>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-img>

              <v-card-title>
                <v-row align="center">
                  <p
                    class="text_block"
                    style="
                      font-size: 16px;
                      color: #000000;
                      opacity: 1;
                      text-align: start;
                      padding-left: 12px;
                      width: 190px;
                      display: inline-block;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                  >
                    {{ item.topicName }}
                  </p>
                </v-row>
              </v-card-title>

              <v-card-subtitle
                style="
                  width: 190px;
                  display: inline-block;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                 
                  "
              >
                {{ item.description }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-card>
    <cancel-save v-if="$store.getters.showLibraryAction" />
    <!-- Add component dialog -->
    <Add
      v-if="addDialog"
      :show="addDialog"
      @close="addDialog = false"
      :sortNumberItem="sortNumberItems"
      :fullName="fullName_"
      @confirm="handleConfirm"
    />
    <!--Edit componetn dialog-->
    <Edit
      v-if="editDialog"
      :editData="editData"
      :show="editDialog"
      @close="editDialog = false"
      :sortNumberItem="sortNumberItems"
      :fullName="fullName_"
      @confirm="handleConfirmedit"
    />
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title style="font-size: 30px; height: 70px">
          <p>{{ $t("deleteconfirm") }}</p>
        </v-card-title>

        <v-card-text>
          <p
            class="mt-5"
            style="font-size: 20px; color: #4d4f5c; text-align: center"
          >
            {{ $t("suredelete") }}
            <br />
            {{ deleteTopicName }} " ?
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize"
            style="font-size: 20px"
            width="100"
            text
            outlined
            @click="deleteDialog = false"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize"
            width="100"
            style="font-size: 20px"
            color="error"
            @click="deleteConfirm()"
            >{{ $t("delete") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete
     <DeleteConfirmDialog
      :text="deleteConfirmText"
      :show="deleteDialog"
      @close="deleteDialog = false"
      @confirm="deleteConfirm"
    />
     -->
    <!-- <SuccessDialog
      :show="successDialog1"
      :title="$t('success')"
      :text="message"
      @close="(successDialog1 = false), getTopic()"
    /> -->
  </div>
</template>
<script>
import CancelSave from "../../../components/cancelSave.vue";
import axios from "axios";
import enurl from "@/api/environment";
import Add from "./add.vue";
import Edit from "./edit.vue";
import TitleBlock from "@/components/global_component/TitleBlock";

export default {
  components: {
    Add,
    Edit,
    CancelSave,
    TitleBlock
  },
  data: () => ({
    breadcrumbs: [
      {
        sidebar_title: "defaultcontent"
      },
      {
        text: "library"
      }
    ],
    message: "",
    fullName_: "",

    deleteDialog: false,
    successDialog1: false,
    addDialog: false,
    editDialog: false,
    editData: {},
    deleteTopicName: null,

    deleteTopic_id: 0,
    url: enurl.apiUrl,
    bullet: "",
    grid: "grid",
    items: [],
    sortNumberItems: [],
    loading: true
  }),
  mounted() {
    this.getTopic();
  },
  computed: {
    deleteConfirmText() {
      return this.$t("suretodeletetopictitle") + ` #${this.deleteTopicName} ?`;
    }
  },
  methods: {
    async deleteConfirm() {
      console.log("hello");
      let data = {
        id: this.deleteTopic_id,
        companyId: "00000000-0000-0000-0000-000000000000"
      };
      console.log("data", data);
      const res = await axios.post(`${this.url}Topic/RemoveTopic`, data);
      if (res.data.status == 0) {
        console.log("res.data.data", res.data.data);
        this.getTopic();
        this.deleteDialog = false;
        this.message = this.$t("deletetopicsuccessful");
        this.successDialog1 = true;
      }
    },

    async checkTopicDelete(item) {
      console.log("hello");

      this.deleteTopicName = item.topicName;
      this.deleteTopic_id = item.id;
      console.log("hello", this.deleteTopicName);
      console.log("hello", this.deleteTopic_id);
      let self = this;
      //  let checkPermission = self.check_Permissions("library");
      //  if (checkPermission) {
      self.deleteDialog = true;
      //   } else {
      //    self.permissionDialog = true;
      //     self.permissionMessage = "You don't have permission to delete Topic.";
    },

    goLibraryWithName(item, show) {
      console.log("go to _library=>", item, show);
      if (show) {
        this.editDialog = true;
        this.editData = item;
      } else {
        console.log("vuex");
        this.$router.push("/default-content/library/" + item.topicName);
        this.$store.commit("saveEditLibrary", item);
        localStorage.setItem("libraryId", item.id);
      }
    },
    handleConfirm() {
      this.addDialog = false;
      this.getTopic();
      this.successDialog1 = true;
      this.message = this.$t("addtopicsuccessful");
    },
    handleConfirmedit() {
      this.editDialog = false;
      this.getTopic();
      this.successDialog1 = true;
      this.message = this.$t("edittopicsuccessful");
    },
    async AddArticle() {
      console.log("hello");
      let self = this;
      self.addDialog = true;
    },
    async EditArticle() {
      console.log("hello");
      let self = this;
      self.editDialog = true;
    },
    async getTopic() {
      let self = this;
      const companyID = "00000000-0000-0000-0000-000000000000";
      //const data = {
      //    companyID: '00000000-0000-0000-0000-000000000000',
      //  };

      //  let policy = localStorage.getItem("policyType");
      //  if (policy == "false") {
      //     self.Dialog = true;
      //    }

      self.loading = true;
      await axios
        .get(`${self.url}Topic/GetTopics?id=` + companyID)
        .then(function(res) {
          console.log("res.data.data", res.data.data);
          self.items = res.data.data.map((v, i) => ({
            ...v,
            no: i + 1
          }));
          console.log("self.items", self.items);
          self.item_no = self.items ? self.items.length : 0;
          let temp_null = [{ value: "" }];
          let temp_num = self.items.map((v, i) => {
            return { value: i + 1 };
          });

          self.sortNumberItems = temp_null.concat(temp_num);
          console.log(self.sortNumberItems);
          //GETTING ANNOUNCEMENT...
          if (self.$store.getters.isLogged_In) {
            // self.getAnnouncement();
          }
        })
        .catch(function(err) {
          alert(err);
        });
      self.loading = false;
    }
  }
};
</script>
<style scoped>
.text_block {
  width: 100%;
  word-break: normal;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0; /* Ensures no padding */
  line-height: 2;
}
.library {
  padding-right: 0px !important;
}
.library_img {
  margin: 0px 12px;
  border-radius: 16px;
}
.library_card:hover .editbtn {
  visibility: visible;
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}
.editbtn:focus {
  background: #ffffff;
  border: 1px solid #ffffff;
}
.library_card .editbtn {
  visibility: hidden;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
}
.library_img_inactive {
  margin: 0px 12px;
  border-radius: 16px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.status {
  border-radius: 6px;
  font-size: 11px;
  text-align: center;
  padding: 2px;
  margin: 12px;
  background: #6fdc42;
  color: #ffffff;
  display: inline-table;
}
.inactive_status {
  border-radius: 6px;
  font-size: 11px;
  text-align: center;
  padding: 2px;
  margin: 12px;
  background: #c4c4c4;
  color: #ffffff;
  display: inline-table;
}
.status_list {
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
  padding: 2px;
  margin: 5px 40px 0px 0px;
  background: #6fdc42;
  color: #ffffff !important;
  display: inline-table;
}
.inactivestatus_list {
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
  padding: 2px;
  margin: 5px 40px 0px 0px;
  background: #c4c4c4;
  color: #ffffff !important;
  display: inline-table;
}
.circle {
  margin-bottom: 2px;
  color: white !important;
  font-size: 8px !important;
}
.editbtn {
  height: 30px !important;
  width: 20px !important;
  min-width: 20px !important;
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  transition: 0.3s;
  border: 1px solid #ffffff;
}
.list_img {
  border-radius: 12px;
}
.inactivelist_img {
  border-radius: 12px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.list-style {
  border-bottom: 1px solid rgba(66, 66, 66, 0.2);
}
</style>

<style>
@media (min-width: 1264px) and (max-width: 1903px) {
  .lg5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
  }
}
</style>

<style scoped>
.list-item-padding.v-sheet.v-list {
  border-radius: 8px !important;
}
.list-item-padding.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
  border-radius: 8px !important;
}
.list-item-padding.list-item-padding.theme--light {
  padding: 0 5px !important;
  min-height: 42px !important;
}
::v-deep .list-item-padding.v-list-item:hover {
  background-color: unset !important;
}
</style>
